import wstethIcon from "../../../media/icons/wsteth.png";

export function WSTETHIcon() {
    return (
        <img className='rounded-full' src={wstethIcon} width={38} height={38} alt='wstETH'/>
    )
}
